import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { SegmentComponent } from './SegmentAnalytics';

export function SegmentPageTracker() {
	const { pathname } = useLocation();

	useEffect(() => {
		SegmentComponent?.page(
			{ title: pathname },
			{
				context: { ip: '0.0.0.0' },
				path: pathname
			}
		);
	}, [pathname]);

	return null;
}
